import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./MyBookings.css";

const BookingDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const booking = useSelector((state) =>
    state.bookings.list.find((b) => b._id === id)
  );

  if (!booking) return <div>No booking found</div>;

  return (
    <div className="bk-container">
      <button className="bk-back" onClick={() => navigate(-1)}>←</button>

      <div className="bk-detail-card">
        <h3>{booking.bookingType.toUpperCase()}</h3>
        <span className="bk-paid">PAID</span>
        <span className="bk-status">BOOKED</span>
        <span className="bk-price">₹{booking.totalAmount}</span>
      </div>

      <div className="bk-section">
        <h4>Booking Information</h4>
        <p><b>Booking ID:</b> {booking.bookingId}</p>
        <p><b>Status:</b> {booking.status}</p>
        <p><b>Slot Number:</b> {booking.slotNumber}</p>
      </div>

      {booking.week && (
        <div className="bk-section">
          <h4>Sponsorship Details</h4>
          <p><b>Week:</b> {booking.week}</p>
          <p><b>Start:</b> {booking.startDate}</p>
          <p><b>End:</b> {booking.endDate}</p>
          <p><b>Page:</b> {booking.pageType}</p>
        </div>
      )}

      <div className="bk-section">
        <h4>Payment Summary</h4>
        <p>Base Price: ₹{booking.price}</p>
        <p>GST (18%): ₹{booking.gstAmount}</p>
        <p><b>Total: ₹{booking.totalAmount}</b></p>
      </div>
    </div>
  );
};

export default BookingDetails;
